import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { ToastrService } from 'ngx-toastr'
import { timer as observableTimer } from 'rxjs'
import { Device, Group } from '../../models'
import { Helpers } from './../../../../helpers'
import { DeviceService } from './../../services/device.service'
declare var jQuery: any

@Component({
  selector: 'device-sync-options',
  templateUrl: './device-sync-options.modal.html'
})
export class DeviceSyncOtionsModal implements OnInit {
  @Input() public deviceIds: string[]
  @Input() public selectedGroup: Group
  @Input() public device: Device
  @Output() public deviceChange: EventEmitter<Device> = new EventEmitter()
  public syncModeCheckbox: number
  public editSyncForm: FormGroup
  public progressPercentage: number = 0
  public scheduledTimeOutput: string[] = []
  public activeSwitch: boolean = true
  constructor(
    private deviceService: DeviceService,
    private _toastr: ToastrService
  ) { }

  public ngOnInit() {
    this.init()
  }
  public init() {
    this.createEditSyncModalForm()
    this.activeSwitch = true
    if (this.device) this.fillForm()
  }

  public checkProgress() {
    if (this.progressPercentage >= 99) {
      this.progressPercentage = 0
    } else {
      observableTimer(400).subscribe(() => {
        this.checkProgress()
      })
    }
  }

  public onEditSyncFormSubmit(device) {
    const deviceCopy = device
    const distributionMode = device['distributionMode-input']

    // Mapping
    device = {
      config: {
        scheduled: null,
        maxRecvKbps: device['maxRecvKbps-input'],
        maxSendKbps: device['maxSendKbps-input']
      }
    }
    if (distributionMode == 2) {
      device.config.scheduled = {
        active: this.activeSwitch,
        start: deviceCopy['initEndScheduled-input'][0],
        end: deviceCopy['initEndScheduled-input'][1]
      }
    }
    // console.log(device)

    // Update
    if (this.device) {
      // single device
      this.deviceService.update(this.device._id, device).subscribe(
        (data) => {
          this.device = data
          this._toastr.success('Device successfully updated!')
          this.dismissModal()
          this.deviceChange.emit(data)
          Helpers.setLoading(false)
        },
        (error) => {
          this._toastr.error('Error updating device!', JSON.stringify(error))
          this.dismissModal()
          Helpers.setLoading(false)
        }
      )
    } else {
      // group of devices
      console.log('editing group')
      this.progressPercentage = 5
      const sumProgress = 100 / this.deviceIds.length

      this.checkProgress()

      this.deviceIds.forEach((id, index) => {
        this.deviceService.update(id, device).subscribe(
          (data) => {
            this.progressPercentage += sumProgress
          },
          (error) => {
            this.progressPercentage += sumProgress
          }
        )
      })

      observableTimer(2000).subscribe(() => {
        this.progressPercentage = 0
      })
    }
  }

  public sliderToTime(e) {
    const init = e.values[0]
    const end = e.values[1]
    const hoursMinutesInit = this.convertHoursMinutes(init)
    const hoursMinutesEnd = this.convertHoursMinutes(end)
    this.scheduledTimeOutput[0] =
      hoursMinutesInit[0] + 'h' + hoursMinutesInit[1]
    this.scheduledTimeOutput[1] = hoursMinutesEnd[0] + 'h' + hoursMinutesEnd[1]
  }

  public switchInitEnd() {
    this.activeSwitch = !this.activeSwitch
  }

  // returns [ hour , minute ]
  public convertHoursMinutes(number) {
    return [Math.floor(number / 60), number % 60]
  }

  public convertHoursMinutesToNumber(hour, minute) {
    return hour * 60 + minute
  }

  private createEditSyncModalForm() {
    const controls = {
      'globalAnnounceServers-input': new FormControl(
        [''],
        [
          // Validators.pattern(/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/)
        ]
      ),
      'maxRecvKbps-input': new FormControl(0, [
        Validators.required,
        Validators.min(0),
        Validators.max(1073741824)
      ]),
      'maxSendKbps-input': new FormControl(0, [
        Validators.required,
        Validators.min(0),
        Validators.max(1073741824)
      ]),
      'distributionMode-input': new FormControl(1, [
        Validators.required,
        Validators.min(1),
        Validators.max(3)
      ]),
      'initEndScheduled-input': new FormControl([0, 510], [])
    }
    this.editSyncForm = new FormGroup(controls) // this.checkTime('timeStart-input', 'timeEnd-input')
    this.sliderToTime({
      values: this.editSyncForm.controls['initEndScheduled-input'].value
    })
  }

  private fillForm() {
    this.syncModeCheckbox = this.device.config.scheduled ? 2 : 1
    this.editSyncForm.controls['globalAnnounceServers-input'].patchValue(
      this.device.config.globalAnnounceServers
    )
    this.editSyncForm.controls['distributionMode-input'].patchValue(
      this.device.config.scheduled ? 2 : 1
    )
    this.editSyncForm.controls['maxRecvKbps-input'].patchValue(
      this.device.config.maxRecvKbps
    )
    this.editSyncForm.controls['maxSendKbps-input'].patchValue(
      this.device.config.maxSendKbps
    )

    if (this.device.config.scheduled) {
      const initEnd = [
        this.device.config.scheduled.start,
        this.device.config.scheduled.end
      ]
      this.activeSwitch = this.device.config.scheduled.active
      if (initEnd[0] != initEnd[1]) {
        this.editSyncForm.controls['initEndScheduled-input'].patchValue(initEnd)
        this.sliderToTime({
          values: this.editSyncForm.controls['initEndScheduled-input'].value
        })
      }
    }
  }

  private dismissModal() {
    jQuery('#cancelButton3').trigger('click')
    jQuery('#cancelButton3').trigger('click')
  }
}
